import { ArrowDown } from "lucide-react";
import { SERVICES } from "./content";

const SPAN = ["lg:col-span-3", "lg:col-span-3", "lg:col-span-2", "lg:col-span-2", "lg:col-span-2"];

const chooseService = (title) => {
  window.dispatchEvent(
    new CustomEvent("dellsjo:select-service", { detail: { service: title } }),
  );
};

const ServiceCard = ({ s, span }) => (
  <a
    href="#offert"
    onClick={() => chooseService(s.title)}
    className={`card-lift group flex flex-col overflow-hidden rounded-2xl border border-[var(--line)] bg-white no-underline focus-visible:outline focus-visible:outline-3 focus-visible:outline-offset-2 focus-visible:outline-[var(--red-bright)] ${span}`}
    data-testid={`service-card-${s.key}`}
    aria-label={`${s.title} – välj tjänsten i offertformuläret`}
  >
    <div className="relative aspect-[16/9] overflow-hidden bg-[var(--sand)]">
      <img src={s.img} alt="" loading="lazy" className="h-full w-full object-cover" />
    </div>
    <div className="flex flex-1 flex-col p-5 sm:p-6">
      <h3 className="text-xl font-bold sm:text-2xl">{s.title}</h3>
      <p className="mt-2 leading-relaxed text-[var(--ink-soft)]">{s.text}</p>
      <span className="mt-auto inline-flex items-center gap-2 pt-5 text-sm font-semibold text-[var(--red)]">
        Välj tjänst <ArrowDown size={16} className="transition-transform group-hover:translate-y-0.5" aria-hidden />
      </span>
    </div>
  </a>
);

export const Services = () => (
  <section id="tjanster" className="pt-14 pb-8 md:pt-20 md:pb-8" data-testid="services-section">
    <div className="mx-auto max-w-6xl px-4 sm:px-6">
      <div className="max-w-2xl">
        <p className="eyebrow">Tjänster</p>
        <h2 className="mt-3 text-3xl font-bold tracking-tight sm:text-4xl">Städning för arbetsplatser och fastigheter</h2>
        <p className="mt-4 text-base text-[var(--ink-soft)] md:text-lg">
          För kontor, bostadsrättsföreningar, fastigheter och byggprojekt. Välj det du behöver hjälp med, så tar vi det därifrån.
        </p>
      </div>
      <div className="mt-9 grid gap-5 md:grid-cols-2 lg:grid-cols-6">
        {SERVICES.map((s, i) => (
          <ServiceCard key={s.key} s={s} span={SPAN[i]} />
        ))}
      </div>
    </div>
  </section>
);
